// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.08238 17.2574L6.67746 15.8525L13.7287 8.79457H8.37534L8.38866 6.86364H17.0645V15.5462H15.1203L15.1336 10.1995L8.08238 17.2574Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
